import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, Select, MenuItem, FormHelperText, SelectChangeEvent } from "@mui/material";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";
import { usePlayingLevels } from "../../../../../../../api/v1/queries/usePlayingLevels";

const PlayingLevelField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<EditEntityProfileData>();

  const { playingLevels, isPlayingLevelsLoading } = usePlayingLevels();
  return (
    <Controller
      name="listEntry"
      control={control}
      render={({ field: { onChange, value = [], ...field }, fieldState: { error } }) => {
        const selectedValues = Array.isArray(value) ? value : [];

        return (
          <FormControl error={!!error} fullWidth>
            <FormLabel
              sx={{
                color: "var(--Dark---800, #414141)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("ageGroupsServed")}
            </FormLabel>
            <Select<number[]>
              {...field}
              multiple
              displayEmpty
              value={selectedValues}
              disabled={isPlayingLevelsLoading}
              onChange={(event: SelectChangeEvent<number[]>) => {
                const newValues = event.target.value as number[];
                onChange(newValues);
              }}
              renderValue={(selected: number[]) => {
                if (selected.length === 0) {
                  return t("selectAgeGroupsServed");
                }
                return playingLevels
                  .filter((level) => selected.includes(level.id))
                  .map((level) => level.name)
                  .join(", ");
              }}
            >
              {playingLevels.map((level) => (
                <MenuItem key={level.id} value={level.id}>
                  {level.name}
                </MenuItem>
              ))}
            </Select>
            {error?.message && <FormHelperText sx={{ color: "#CC3E3E" }}>{t(error.message)}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
};

export default PlayingLevelField;
